export const FIELD_SUBSCRIPTION = { value: true, error: true, touched: true };

export const required = (value) => (value ? undefined : 'Required');
